import { Component, HostBinding, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { PrintService } from '../../../print/print.service';

export interface DialogOrderDetailData {
	order: string;
}

@Component({
	selector: 'order-detail-dialog',
	templateUrl: 'order-detail.dialog.component.html',
	styleUrls: ['./order-detail.dialog.component.scss']
})
export class OrderDetailDialogComponent {

	public m_selectedOrder: string = '';
	public m_isPrinting: boolean = false;
	@HostBinding('class.flex-fill') someField: boolean = false;

	constructor(
		private m_printService: PrintService,
		public m_dialogRef: MatDialogRef<OrderDetailDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public m_data: DialogOrderDetailData,
	) {
		this.m_selectedOrder = this.m_data.order;
		this.someField = true;
	}


	public printOrder_Click(): void {
		// Drucken-Dialog öffnen
		this.m_printService.printDocument('bestellung', this.m_selectedOrder);
	}


	/**
	 * Der modale Dialog wird geschlossen.
	 */
	public backDialog_Click(): void {
		this.m_dialogRef.close();
	}

}
